// actions/villagers.ts — M2
import { defineAction, type Ok } from '../define';
import { g } from '../guard';
import type { ItemId, VillagerId } from '../../types/ids';
import type { DialogueLine } from '../../types/villagers';
declare module '../registry' {
  interface ActionMap {
    'villager.talk': { req: { villager: VillagerId }; res: { convo: string; lines: DialogueLine[] } };
    'villager.talkEnd': { req: { convo: string }; res: Ok };
    'villager.gift': { req: { convo: string; item: ItemId }; res: { lines: DialogueLine[]; points: number } };
    'villager.protect': { req: { villager: VillagerId; protect: boolean }; res: Ok };
  }
}
export const villagerTalk = defineAction('villager.talk', g.obj({ villager: g.id<VillagerId>('v') }));
export const villagerTalkEnd = defineAction('villager.talkEnd', g.obj({ convo: g.token }));
export const villagerGift = defineAction('villager.gift', g.obj({ convo: g.token, item: g.id<ItemId>('i') }));
export const villagerProtect = defineAction('villager.protect', g.obj({ villager: g.id<VillagerId>('v'), protect: g.bool }));
